import Icon from '../components/Icon.vue'

Icon.register({"eraser":{"width":1920,"height":1792,"paths":[{"d":"M896 1408l336-384h-768l-336 384h768zM1909 331q15 34 9.5 71.5t-30.5 65.5l-896 1024q-38 44-96 44h-768q-38 0-69.5-20.5t-47.5-54.5q-15-34-9.5-71.5t30.5-65.5l896-1024q38-44 96-44h768q38 0 69.5 20.5t47.5 54.5z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/eraser.js
// module id = 520
// module chunks = 0